import { lazy } from "react";
import { Navigate, useParams } from "react-router-dom";
import Loadable from "app/components/Loadable";
import ModuleAdminRouteGuard, {
  ModuleAdminDetailRouteGuard,
} from "./moduleAdmin/ModuleAdminRouteGuard";

// User assignment pages
const UserRoles = Loadable(lazy(() => import("./UserRolesList")));
const UserRolesEdit = Loadable(lazy(() => import("./UserRolesAdd")));
const ModuleAdminOverview = Loadable(
  lazy(() => import("./moduleAdmin/ModuleAdminOverview")),
);
const ModuleAdminDetail = Loadable(
  lazy(() => import("./moduleAdmin/ModuleAdminDetail")),
);

// Generic reusable component for roles per system
const RoleManagement = Loadable(lazy(() => import("./RoleManagementPanel")));

function ModuleAdminOverviewRedirect() {
  return <Navigate to="/users/manage-roles" replace />;
}

function ModuleAdminDetailRedirect() {
  const { moduleKey } = useParams();
  return (
    <Navigate
      to={`/users/manage-roles/${encodeURIComponent(moduleKey || "")}`}
      replace
    />
  );
}

function ModuleAdminDetailRoute() {
  const { moduleKey } = useParams();
  return (
    <ModuleAdminDetailRouteGuard moduleKey={moduleKey}>
      <ModuleAdminDetail />
    </ModuleAdminDetailRouteGuard>
  );
}

const UserRolesRoutes = [
  // Legacy user-centric assignment table (unchanged)
  { path: "/users/manage-user-roles", element: <UserRoles /> },
  { path: "/users/manage-user-roles/:mode/:id", element: <UserRolesEdit /> },

  // Module-centric assignment (primary)
  {
    path: "/users/manage-roles",
    element: (
      <ModuleAdminRouteGuard>
        <ModuleAdminOverview />
      </ModuleAdminRouteGuard>
    ),
  },
  {
    path: "/users/manage-roles/itcms",
    element: (
      <RoleManagement
        moduleName="ITCMS"
        routeSegments={[
          {
            name: "Manage ITCMS user roles",
            path: "/users/manage-roles",
            showSelection: true,
          },
          { name: "ITCMS Role Management" },
        ]}
      />
    ),
  },
  {
    path: "/users/manage-roles/adms",
    element: (
      <RoleManagement
        moduleName="ADS"
        routeSegments={[
          {
            name: "Manage ADMS user roles",
            path: "/users/manage-roles",
            showSelection: true,
          },
          { name: "ADMS Role Management" },
        ]}
      />
    ),
  },
  { path: "/users/manage-roles/:moduleKey", element: <ModuleAdminDetailRoute /> },

  // Compatibility redirects — old module-admin URLs
  { path: "/users/module-admin", element: <ModuleAdminOverviewRedirect /> },
  { path: "/users/module-admin/:moduleKey", element: <ModuleAdminDetailRedirect /> },

  // Phase 1 role-centric routes → module admin overview
  { path: "/users/role-admin", element: <Navigate to="/users/manage-roles" replace /> },
  {
    path: "/users/role-admin/:roleId",
    element: <Navigate to="/users/manage-roles" replace />,
  },
];

export default UserRolesRoutes;
